import React from 'react'
import SVGA from 'svgaplayerweb'
import ReactDOM from 'react-dom'

import './index.less'
let loadingContainer = null

const LoadingSVGA = () => {
  return ReactDOM.createPortal(
    <div className={`loading-svga-root`}>
      <div className="loader-compbox">
        <div className="chatie" id="loadingCanvas" src={`/img/ani_web_loading.svga`}>
          <img src="https://h5-activity.yayya.live/img/loading.gif" alt="" />
        </div>
      </div>
    </div>,
    loadingContainer,
  )
}

const init = () => {
  const loadingInstance = new SVGA.Player('#loadingCanvas')
  const loadoingParser = new SVGA.Parser('#loadingCanvas')
  loadoingParser.load('/img/activity/national-star/ani_web_loading.svga', (videoItem) => {
    loadingInstance.setVideoItem(videoItem)
    loadingInstance.startAnimation()
  })
}

const Loading = {
  show: () => {
    if (!loadingContainer) {
      loadingContainer = document.createElement('div')
      document.body.appendChild(loadingContainer)
    }

    // Render the Toast component
    ReactDOM.render(<LoadingSVGA />, loadingContainer)
    // init()
  },
  hide: () => {
    ReactDOM.unmountComponentAtNode(loadingContainer)
    loadingContainer = null
  },
}

export default Loading



// WEBPACK FOOTER //
// src/pages/activity/national-star/loading-svga/index.js